import { useToast } from '@chakra-ui/react';
import { TField } from './Form';
import { isEmpty } from '../../helpers';
import { keys } from 'lodash';

const useRequiredValidation = () => {
  const toast = useToast();

  return (inputs: TField[], formData: Record<string, any>, setErrors: any) => {
    setErrors({});

    const errs = inputs.reduce((prev, input) => {
      return input.name_id &&
        input.required &&
        (!input.condition || input.condition?.(formData)) &&
        isEmpty(formData[`${input.name_id}`])
        ? { ...prev, [input.name_id]: { tabId: 'stats' } }
        : prev;
    }, {} as Record<string, { tabId?: string }>);

    if (keys(errs).length) {
      setErrors(errs);

      toast({
        title: 'Certains champs obligatoires n’ont pas été renseignés',
        status: 'error',
      });

      return false;
    }

    return true;
  };
};

export default useRequiredValidation;
